import SectionCardContent from './SectionCardContent';

export default SectionCardContent;
